export const reviews = [
  {
    id: 1,
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20portrait%20in%20casual%20business%20attire%2C%20warm%20friendly%20expression%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%20with%20shallow%20depth%20of%20field&width=80&height=80&seq=avatar-1&orientation=squarish',
    rating: 5,
    date: '2026-08-05',
    content: '使用皇冠App已经一年多了，体验一直很稳定。界面设计简洁大方，操作流畅不卡顿，客服响应也很快。特别是最新的v5.2.0版本，UI升级后更加美观了，推荐给身边很多朋友都在用。',
    location: '北京',
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20portrait%20with%20warm%20smile%2C%20modern%20casual%20style%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20photography%20with%20gentle%20expression&width=80&height=80&seq=avatar-2&orientation=squarish',
    rating: 5,
    date: '2026-08-03',
    content: '之前不小心下载到了山寨版本，后来通过官网重新下载了正版皇冠App，体验完全是天壤之别！正版功能齐全、运行流畅，而且有完善的安全保护。大家一定要认准官方渠道下载。',
    location: '上海',
  },
  {
    id: 3,
    name: '王先生',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20male%20portrait%2C%20friendly%20confident%20expression%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20modern%20headshot%20style%20photography&width=80&height=80&seq=avatar-3&orientation=squarish',
    rating: 4,
    date: '2026-08-01',
    content: '皇冠App的功能覆盖很全面，基本上我需要用到的功能都能找到。新版本的智能推荐功能特别好用，推送的内容越来越精准了。唯一希望改进的是深色模式的色调可以再柔和一些。',
    location: '广州',
  },
  {
    id: 4,
    name: '赵女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20portrait%20elegant%20style%2C%20warm%20genuine%20smile%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-4&orientation=squarish',
    rating: 5,
    date: '2026-07-28',
    content: '从皇冠App早期版本就在用了，见证了它的每一次更新迭代。开发团队真的很用心，每个版本都有实实在在的改进。安全方面也做得很到位，多重验证让人很放心。强烈推荐！',
    location: '深圳',
  },
  {
    id: 5,
    name: '陈先生',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20professional%20male%20portrait%2C%20warm%20trustworthy%20expression%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-5&orientation=squarish',
    rating: 5,
    date: '2026-07-25',
    content: '作为一名技术从业者，我对应用的安全性和性能要求比较高。皇冠App在这两方面都做得非常出色，代码质量和架构设计可以看出团队的专业水准。数据加密和隐私保护也让我很满意。',
    location: '杭州',
  },
  {
    id: 6,
    name: '刘女士',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20female%20portrait%2C%20bright%20friendly%20smile%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20modern%20headshot%20photography&width=80&height=80&seq=avatar-6&orientation=squarish',
    rating: 4,
    date: '2026-07-20',
    content: '朋友推荐下载的皇冠App，使用了一个月感觉很不错。界面很清爽，没有乱七八糟的广告。新手引导做得也很友好，上手很快。客服回复效率高，遇到问题都能及时解决。',
    location: '成都',
  },
];

export const reviewStats = {
  averageRating: 4.8,
  totalReviews: 12580,
  ratingDistribution: [
    { stars: 5, percentage: 82 },
    { stars: 4, percentage: 13 },
    { stars: 3, percentage: 3 },
    { stars: 2, percentage: 1 },
    { stars: 1, percentage: 1 },
  ],
};